import { Tag } from "components/DesignSystem/Tag/Tag";
import { EditPencil } from "components/icons/EditPencil";
import { Trash20 } from "components/icons/Trash20";
import { EntityFlagAvatar } from "../../EntityFlagAvatar";

type RelationTag = "Parent" | "Subsidiary";

type EntityCardProps = {
  name: string;
  entityTypeLabel: string;
  addressString: string;
  countryCode?: string;
  relationTag?: RelationTag;
  isPrimary?: boolean;
  onEdit?: () => void;
  onNotMyCompany?: () => void;
  onRemove?: () => void;
};

export const EntityCard = ({
  name,
  entityTypeLabel,
  addressString,
  countryCode,
  relationTag,
  isPrimary = false,
  onEdit,
  onNotMyCompany,
  onRemove,
}: EntityCardProps) => {
  return (
    <div className="t-flex t-items-start t-gap-2 t-rounded-md t-border t-border-solid t-border-neutral-10 t-p-4 sm:t-flex-wrap sm:t-gap-y-3">
      <EntityFlagAvatar countryCode={countryCode} />
      <div className="t-flex t-min-w-0 t-flex-1 t-flex-col t-gap-0.5">
        <div className="t-flex t-items-center t-gap-2.5">
          <span className="t-text-body t-font-medium t-text-text-60">
            {name}
          </span>
          {relationTag && (
            <Tag rounded icon={false} tagType="gray" size="small">
              {relationTag}
            </Tag>
          )}
        </div>
        <span className="t-text-body t-text-neutral-40">{entityTypeLabel}</span>
        {Boolean(addressString) && (
          <span className="t-text-body t-text-neutral-40">
            Address: {addressString}
          </span>
        )}
      </div>
      <div className="t-flex t-shrink-0 t-items-center t-gap-3 sm:t-w-full sm:t-justify-end">
        {isPrimary && onNotMyCompany && (
          <button
            type="button"
            onClick={onNotMyCompany}
            className="all:unset t-cursor-pointer t-text-body-sm t-text-text-30 hover:t-text-text-60"
          >
            This isn&apos;t my company
          </button>
        )}
        {onEdit && (
          <button
            type="button"
            onClick={onEdit}
            className="all:unset t-flex t-cursor-pointer t-text-text-30 hover:t-text-text-60"
            title="Edit"
          >
            <EditPencil />
          </button>
        )}
        {onRemove && (
          <button
            type="button"
            onClick={onRemove}
            className="all:unset t-flex t-cursor-pointer t-text-text-30 hover:t-text-red"
            title="Remove"
          >
            <Trash20 className="t-size-4" />
          </button>
        )}
      </div>
    </div>
  );
};
